import React from 'react';
import { MultiSelect } from "react-multi-select-component";

import './MultiSelectDropdown.scss';

const MultiSelectDropdown = ({ id, options, selected, onChange, disabledMode, isLoading, hasSelectAll, valueRenderer }) => {

  return (
    <div className={'parkchirp--input-multiselect-field' + (disabledMode ? ' disabled' : '')}>
      <MultiSelect
        id={`${id}-inner`}
        options={options}
        value={selected}
        onChange={onChange}
        labelledBy="Select"
        disableSearch={true}
        hasSelectAll={hasSelectAll}
        disabled={disabledMode}
        isLoading={isLoading}
        ClearSelectedIcon={null}
        valueRenderer ={valueRenderer}
      />
    </div>

  );
}


export default MultiSelectDropdown;
